import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/* eslint-disable no-console -- Will be removed after error handling will be known, local environment is not working correctly for login.*/
import { ArrowLeftThin } from '@ori-ui/icons';
import { ButtonBase, styled, Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { Formik, Form } from 'formik';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { CHANGE_FORGOTTEN_PASSWORD_URL, CONSULTANT_NUMBER_QUERY_PARAM_KEY, DO_LOGIN_URL, RETURN_URL_QUERY_PARAM_KEY, VALIDATE_LOGIN_URL } from '../../constants';
import { useConfigurationContext } from '../../contexts/ConfigurationContext';
import { buildPasswordRequirementsSchema, getCustomAxios, handleAxiosError } from '../../helpers';
import { AccountPanes } from '../../models';
import { useChangePasswordMetadataQuery } from '../../models/api';
import { LocalizationKeys } from '../../models/localizationKeys';
import { Loading } from '../Loading';
import { Input } from './Input';
import { PasswordInput } from './PasswordInput';
import { PasswordRequirements } from './PasswordRequirements';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var NewPasswordRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: 'calc(100% - var(--top-nav-height))',
    padding: theme.spacing(3, 4)
  };
});
var NewPasswordHeader = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    display: 'flex',
    marginBottom: theme.spacing(6)
  };
});
var NewPasswordHeaderBack = styled(ButtonBase)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(28),
    '&:hover, &:focus, &:active': {
      color: theme.palette.text.disabled
    }
  };
});
var NewPasswordHeaderTitle = styled(Typography)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.pxToRem(27),
    marginRight: theme.spacing(5),
    textAlign: 'center',
    width: '100%'
  };
});
var NewPasswordForm = styled(Form)(function () {
  return {
    display: 'flex',
    flexDirection: 'column'
  };
});
var NewPasswordFormError = styled('div')(function (_ref5) {
  var theme = _ref5.theme;
  return {
    color: theme.palette.error.main,
    margin: theme.spacing(0, 2)
  };
});
var NewPasswordFormSubmit = styled(ButtonBase)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    background: theme.palette.primary.main,
    borderRadius: 20,
    color: theme.palette.common.white,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.pxToRem(22),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2, 0),
    textAlign: 'center',
    textTransform: 'uppercase'
  };
});

var consoleLogIfDebug = function consoleLogIfDebug() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    console.log(data);
  }
};

export var NewPassword = function NewPassword(_ref7) {
  var goToPane = _ref7.goToPane,
      username = _ref7.username;
  var formRef = useRef(null);

  var _useTranslation = useTranslation(),
      _useTranslation2 = _slicedToArray(_useTranslation, 1),
      translate = _useTranslation2[0];

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      returnUrl = _useState4[0],
      setReturnUrl = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSubmitLocked = _useState6[0],
      setIsSubmitLocked = _useState6[1];

  var changeForgottenPasswordUrl = new URL(CHANGE_FORGOTTEN_PASSWORD_URL, window.location.origin);
  var validateLoginUrl = new URL(VALIDATE_LOGIN_URL, window.location.origin);
  var doLoginUrl = new URL(DO_LOGIN_URL, window.location.origin);

  var _URL = new URL(window.location.href),
      searchParams = _URL.searchParams;

  var url = searchParams.get(RETURN_URL_QUERY_PARAM_KEY);
  var consultantNumber = searchParams.get(CONSULTANT_NUMBER_QUERY_PARAM_KEY);

  var _useConfigurationCont = useConfigurationContext(),
      currentLanguage = _useConfigurationCont.currentLanguage;

  var _useTestId = useTestId(),
      getTestId = _useTestId.getTestId;

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      isInUnknownState = _useState8[0],
      setIsInUnknownState = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      arePasswordRequirementsShown = _useState10[0],
      setArePasswordRequirementsShown = _useState10[1];

  var handleGoBackLinkClicked = useCallback(function () {
    return goToPane(AccountPanes.ForgotPassPane);
  }, [goToPane]);
  var metadata = useChangePasswordMetadataQuery();
  var isLoading = !metadata;

  var getPasswordRequirements = function getPasswordRequirements() {
    var _metadata$newPassword, _metadata$newPassword2, _metadata$newPassword3, _metadata$newPassword4, _metadata$newPassword5, _metadata$newPassword6, _metadata$newPassword7, _metadata$newPassword8, _metadata$newPassword9, _metadata$newPassword11, _metadata$newPassword12, _metadata$newPassword13, _metadata$newPassword15, _metadata$newPassword16, _metadata$newPassword17, _metadata$newPassword19, _metadata$newPassword20, _metadata$newPassword21, _metadata$newPassword23, _metadata$newPassword24, _metadata$newPassword25;

    var minLength = (_metadata$newPassword = metadata === null || metadata === void 0 ? void 0 : (_metadata$newPassword2 = metadata.newPassword) === null || _metadata$newPassword2 === void 0 ? void 0 : (_metadata$newPassword3 = _metadata$newPassword2.validation) === null || _metadata$newPassword3 === void 0 ? void 0 : _metadata$newPassword3.minLength) !== null && _metadata$newPassword !== void 0 ? _metadata$newPassword : 6;
    var maxLength = (_metadata$newPassword4 = metadata === null || metadata === void 0 ? void 0 : (_metadata$newPassword5 = metadata.newPassword) === null || _metadata$newPassword5 === void 0 ? void 0 : (_metadata$newPassword6 = _metadata$newPassword5.validation) === null || _metadata$newPassword6 === void 0 ? void 0 : _metadata$newPassword6.maxLength) !== null && _metadata$newPassword4 !== void 0 ? _metadata$newPassword4 : 255;
    var requirements = [];

    if (metadata !== null && metadata !== void 0 && (_metadata$newPassword7 = metadata.newPassword) !== null && _metadata$newPassword7 !== void 0 && (_metadata$newPassword8 = _metadata$newPassword7.requirements) !== null && _metadata$newPassword8 !== void 0 && (_metadata$newPassword9 = _metadata$newPassword8.letter) !== null && _metadata$newPassword9 !== void 0 && _metadata$newPassword9.isRequired) {
      var _metadata$newPassword10;

      requirements.push({
        key: 'letter-requirement',
        localizedText: translate(LocalizationKeys.passwordRequirementLetter.id),
        validationRegex: new RegExp((_metadata$newPassword10 = metadata.newPassword.requirements.letter.regularExpression) !== null && _metadata$newPassword10 !== void 0 ? _metadata$newPassword10 : '')
      });
    }

    if (metadata !== null && metadata !== void 0 && (_metadata$newPassword11 = metadata.newPassword) !== null && _metadata$newPassword11 !== void 0 && (_metadata$newPassword12 = _metadata$newPassword11.requirements) !== null && _metadata$newPassword12 !== void 0 && (_metadata$newPassword13 = _metadata$newPassword12.lowercaseLetter) !== null && _metadata$newPassword13 !== void 0 && _metadata$newPassword13.isRequired) {
      var _metadata$newPassword14;

      requirements.push({
        key: 'lower-case-requirement',
        localizedText: translate(LocalizationKeys.passwordRequirementLowerCaseLetter.id),
        validationRegex: new RegExp((_metadata$newPassword14 = metadata.newPassword.requirements.lowercaseLetter.regularExpression) !== null && _metadata$newPassword14 !== void 0 ? _metadata$newPassword14 : '')
      });
    }

    if (metadata !== null && metadata !== void 0 && (_metadata$newPassword15 = metadata.newPassword) !== null && _metadata$newPassword15 !== void 0 && (_metadata$newPassword16 = _metadata$newPassword15.requirements) !== null && _metadata$newPassword16 !== void 0 && (_metadata$newPassword17 = _metadata$newPassword16.uppercaseLetter) !== null && _metadata$newPassword17 !== void 0 && _metadata$newPassword17.isRequired) {
      var _metadata$newPassword18;

      requirements.push({
        key: 'upper-case-requirement',
        localizedText: translate(LocalizationKeys.passwordRequirementUpperCaseLetter.id),
        validationRegex: new RegExp((_metadata$newPassword18 = metadata.newPassword.requirements.uppercaseLetter.regularExpression) !== null && _metadata$newPassword18 !== void 0 ? _metadata$newPassword18 : '')
      });
    }

    requirements.push({
      key: 'length-requirement',
      localizedText: translate(LocalizationKeys.passwordRequirementCharactersCount.id, {
        0: minLength
      }),
      validationRegex: new RegExp("^.{".concat(minLength, ",").concat(maxLength, "}$"))
    });

    if (metadata !== null && metadata !== void 0 && (_metadata$newPassword19 = metadata.newPassword) !== null && _metadata$newPassword19 !== void 0 && (_metadata$newPassword20 = _metadata$newPassword19.requirements) !== null && _metadata$newPassword20 !== void 0 && (_metadata$newPassword21 = _metadata$newPassword20.digit) !== null && _metadata$newPassword21 !== void 0 && _metadata$newPassword21.isRequired) {
      var _metadata$newPassword22;

      requirements.push({
        key: 'digit-requirement',
        localizedText: translate(LocalizationKeys.passwordRequirementDigit.id),
        validationRegex: new RegExp((_metadata$newPassword22 = metadata.newPassword.requirements.digit.regularExpression) !== null && _metadata$newPassword22 !== void 0 ? _metadata$newPassword22 : '')
      });
    }

    if (metadata !== null && metadata !== void 0 && (_metadata$newPassword23 = metadata.newPassword) !== null && _metadata$newPassword23 !== void 0 && (_metadata$newPassword24 = _metadata$newPassword23.requirements) !== null && _metadata$newPassword24 !== void 0 && (_metadata$newPassword25 = _metadata$newPassword24.specialCharacter) !== null && _metadata$newPassword25 !== void 0 && _metadata$newPassword25.isRequired) {
      var _metadata$newPassword26;

      requirements.push({
        key: 'special-character-requirement',
        localizedText: translate(LocalizationKeys.passwordRequirementSpecialCharacter.id),
        validationRegex: new RegExp((_metadata$newPassword26 = metadata.newPassword.requirements.specialCharacter.regularExpression) !== null && _metadata$newPassword26 !== void 0 ? _metadata$newPassword26 : '')
      });
    }

    return requirements;
  };

  var passwordRequirements = getPasswordRequirements();
  var passwordSchema = buildPasswordRequirementsSchema(passwordRequirements);
  var loginSchema = Yup.object().shape({
    ConfirmNewPassword: Yup.string().required(translate(LocalizationKeys.enterPassword.id)).test('passwords-match', translate(LocalizationKeys.confirmNewPasswordDoesNotMatch.id), function passwordMatch(value) {
      // eslint-disable-next-line react/no-this-in-sfc, @typescript-eslint/no-invalid-this -- needed for Yup library validation
      return this.parent.NewPassword === value;
    }),
    NewPassword: passwordSchema,
    TemporaryPassword: Yup.string().required(translate(LocalizationKeys.enterPassword.id)),
    Username: Yup.string().required(translate(LocalizationKeys.enterEmailOrBrandPartnerNumber.id))
  });

  var loginAfterForgottenPassSuccessResponse = async function loginAfterForgottenPassSuccessResponse(values) {
    var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (success) {
      try {
        var loginValidateResponse = await getCustomAxios(currentLanguage).post(validateLoginUrl.toString(), values);

        if (loginValidateResponse.data.Success) {
          try {
            if (!formRef.current) {
              return;
            }

            formRef.current.submit();
          } catch (_unused) {
            setErrorMessage(translate(LocalizationKeys.errorOccured.id));
          }

          return;
        }

        consoleLogIfDebug(loginValidateResponse.data);
      } catch (error) {
        handleAxiosError({
          error: error,
          translateMessage: function translateMessage(key) {
            return setErrorMessage(translate(key));
          }
        });
        setIsSubmitLocked(false);
      }
    }
  };

  var onChangeForgottenPassSubmit = function onChangeForgottenPassSubmit() {
    return async function (values, actions) {
      actions.setSubmitting(false);
      setErrorMessage(null);

      if (!isSubmitLocked) {
        setIsSubmitLocked(true);

        try {
          var changeForgottenPassResponse = await getCustomAxios(currentLanguage).put(changeForgottenPasswordUrl.toString(), values);
          await loginAfterForgottenPassSuccessResponse(values, changeForgottenPassResponse.data.Success);
          consoleLogIfDebug(changeForgottenPassResponse.data);
        } catch (error) {
          handleAxiosError({
            error: error,
            translateMessage: function translateMessage(key) {
              return setErrorMessage(translate(key));
            }
          });
          setIsSubmitLocked(false);
        }
      }
    };
  };

  useEffect(function () {
    if (!url) {
      return;
    }

    setReturnUrl(url);
  }, [url]);
  return /*#__PURE__*/_jsxs(NewPasswordRoot, {
    children: [/*#__PURE__*/_jsxs(NewPasswordHeader, {
      children: [/*#__PURE__*/_jsx(NewPasswordHeaderBack, {
        disableRipple: true,
        onClick: handleGoBackLinkClicked,
        children: /*#__PURE__*/_jsx(ArrowLeftThin, {
          fontSize: "inherit"
        })
      }), /*#__PURE__*/_jsx(NewPasswordHeaderTitle, {
        variant: "h6",
        "data-testid": getTestId('new-password-header-title'),
        children: translate(LocalizationKeys.newPassword.id)
      })]
    }), /*#__PURE__*/_jsx(Formik, {
      validateOnChange: true,
      validateOnBlur: true,
      initialValues: {
        Username: consultantNumber !== null && consultantNumber !== void 0 ? consultantNumber : username,
        TemporaryPassword: '',
        NewPassword: '',
        ConfirmNewPassword: '',
        Password: ''
      },
      validationSchema: loginSchema,
      onSubmit: onChangeForgottenPassSubmit(),
      children: function children(_ref8) {
        var _errors$NewPassword;

        var values = _ref8.values,
            validateField = _ref8.validateField,
            errors = _ref8.errors,
            setFieldTouched = _ref8.setFieldTouched;
        return isLoading ? /*#__PURE__*/_jsx(Loading, {}) : /*#__PURE__*/_jsxs(NewPasswordForm, {
          ref: formRef,
          method: "POST",
          action: doLoginUrl.toString(),
          children: [errorMessage && /*#__PURE__*/_jsx(NewPasswordFormError, {
            "data-testid": getTestId('new-password-form-error'),
            children: errorMessage
          }), /*#__PURE__*/_jsx(Input, {
            autoComplete: "username",
            type: "text",
            name: "Username",
            label: "".concat(translate(LocalizationKeys.emailAddressOrRegistrationNumber.id), "*"),
            defaultValue: consultantNumber !== null && consultantNumber !== void 0 ? consultantNumber : username
          }), /*#__PURE__*/_jsx(PasswordInput, {
            name: "TemporaryPassword",
            label: translate(LocalizationKeys.temporaryPassword.id)
          }), /*#__PURE__*/_jsx(PasswordInput, {
            passwordRequirementsValidation: true,
            autoComplete: "new-password",
            name: "NewPassword",
            label: translate(LocalizationKeys.newPassword.id),
            handleKeyUp: function handleKeyUp() {
              if (isInUnknownState) {
                setIsInUnknownState(false);
              }

              setFieldTouched('NewPassword');
              validateField('NewPassword');
            },
            handleOnBlur: function handleOnBlur() {
              if (isInUnknownState) {
                setIsInUnknownState(false);
              }
            },
            handleOnFocus: function handleOnFocus() {
              setArePasswordRequirementsShown(true);
            }
          }), arePasswordRequirementsShown || errors.NewPassword && !isInUnknownState ? /*#__PURE__*/_jsx(PasswordRequirements, {
            isInUnknownState: isInUnknownState,
            requirements: passwordRequirements,
            unfulfilledRequirementKeys: (_errors$NewPassword = errors.NewPassword) === null || _errors$NewPassword === void 0 ? void 0 : _errors$NewPassword.split('|').filter(function (element) {
              return element;
            })
          }) : null, /*#__PURE__*/_jsx(PasswordInput, {
            isHidden: true,
            autoComplete: "new-password",
            name: "Password",
            label: translate(LocalizationKeys.password.id),
            type: "password",
            passwordValue: values.NewPassword
          }), /*#__PURE__*/_jsx(PasswordInput, {
            autoComplete: "new-password",
            name: "ConfirmNewPassword",
            label: translate(LocalizationKeys.confirmNewPassword.id)
          }), /*#__PURE__*/_jsx("input", {
            hidden: true,
            readOnly: true,
            name: "ReturnUrl",
            value: returnUrl
          }), /*#__PURE__*/_jsx(NewPasswordFormSubmit, {
            disableRipple: true,
            type: "submit",
            "data-testid": getTestId('new-password-form-submit'),
            onClick: function onClick() {
              if (isInUnknownState) {
                setIsInUnknownState(false);
              }
            },
            children: translate(LocalizationKeys.signIn.id)
          })]
        });
      }
    })]
  });
};